import { Functions } from "firebase/functions";

export const httpsRequest = <TReq, TRes>(
  functions: Functions,
  name: string,
) => {
  const { projectId } = functions.app.options;
  const url = `https://${functions.region}-${projectId}.cloudfunctions.net/${name}`;

  return async (data: TReq): Promise<TRes> => {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      const errorBody = await res.json().catch(() => ({}));
      throw new Error(
        `${name} failed (${res.status}): ${errorBody.error ?? res.statusText}`,
      );
    }

    return res.json();
  };
};
